import React, { Component } from 'react';
import './Lojas.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { Link, Redirect, withRouter } from 'react-router-dom';

import { connect } from "react-redux";
import { bindActionCreators } from "redux"
import * as Actions from "../../store/actions"

import services from '../../services';



class Loja extends Component {

	state = {
		goPedidos: false,
		lojas: '',
		index_loja: 0
	}



	resolveImage = (imagem) => {
		return imagem ? `${imagem}` : `assets/indisponivel.png`
	}

	goLacaPedido = (index) => {

		services.setLastStore(JSON.stringify(this.props.data[index]));
		this.props.setStores(this.props.data[index]);
		this.props.history.push('LancaPedido');

		// if (this.props.logado)
		// 	this.setState({ goPedidos: true })
		// else
		// 	alert('Você precisa estar logado para entrar e alguma loja');

	}


	render() {


		if (this.state.goPedidos) {
			return <Redirect to={{ pathname: "LancaPedido", dados_loja: this.props.data[this.state.index_loja], logado: true, state: { from: '/' } }} />
		} else {

			return (
				<div className="row">
					{this.props.data ? (

						this.props.data.map((item, index) => {
							return (
								<>
									<div className="col col-md-4 cursorLoja" key={item.id_loja} onClick={() => this.goLacaPedido(index)}>
										<div className="ui link teste">
											<div className="card centralizaCard">
												<div className="image">
													<img src={this.resolveImage(item.imagem)} />
												</div>
												<div className="content">
													<div className="description">
														<p className="lojaName">{item.descricao}</p>
														<p className="lojaPhone"><FontAwesomeIcon icon={faPhone} className="phoneIcon" />{`(${item.ddd}) ${item.telefone}`}</p>
													</div>
												</div>
											</div>
										</div>
									</div>




								</>

							);
						})) : <p>Lojas não encontradas</p>}
				</div>
			);
		}
	}
}



const mapStateToProps = state => ({
	rdUser: state.user,
	rdOrder: state.order,
	rdStores: state.stores
})

const mapDispathToPros = dispatch => bindActionCreators(Actions, dispatch)

export default withRouter(connect(mapStateToProps, mapDispathToPros)(Loja))




// `url('assets/indisponivel.png') no-repeat center`